/**
 * Web shim for @react-native-community/blur
 * Uses a semi-transparent background (0.8 opacity) on web.
 */

import React from 'react';
import { View } from 'react-native';

interface BlurViewProps {
  style?: any;
  blurType?: string;
  blurAmount?: number;
  reducedTransparencyFallbackColor?: string;
  children?: React.ReactNode;
}

export const BlurView: React.FC<BlurViewProps> = ({
  style,
  blurType,
  children,
}) => {
  const isDark = blurType?.toLowerCase().includes('dark');
  const bg = isDark
    ? 'rgba(30, 30, 35, 0.8)'
    : 'rgba(255, 255, 255, 0.8)';

  return (
    <View style={[style, { backgroundColor: bg } as any]}>
      {children}
    </View>
  );
};

export default BlurView;
